import { API_URLS } from '../../../constants/urls/api-urls';
import { delData, getData, postData } from '../../../utils/fetch-api-util';

export const WIDGET_TYPE = {
  MARQUEE: 'MARQUEE',
  PROMOTION: 'PROMOTION',
};
export interface ScheduleTilesType {
  widgetId: string;
  activeAt?: string;
  widgetType?: string;
  id?: string;
  inActiveAt?: string;
  isRunActive?: boolean;
  isRunInActive?: boolean;
  questionTitle?: string;
}
export interface ScheduleTilesPayload {
  widgetId: string;
  widgetType: string;
  activeAt?: string;
  inActiveAt?: string;
}

interface SuccessResponse {
  success: boolean;
}

export const getScheduleTileWidgetById = async (widgetId: string, widgetType: string): Promise<ScheduleTilesType> => {
  const response = await getData<any, ScheduleTilesType>(API_URLS.GET_SCHEDULE_TILE_WIDGET(widgetId, widgetType));
  return response.data;
};

export const postScheduleAddUpdateTileWidgetRepository = async (payload: ScheduleTilesPayload): Promise<void> => {
  await postData<ScheduleTilesPayload, SuccessResponse>(API_URLS.SCHEDULE_ADD_UPDATE_TILE_WIDGET, payload);
};

export const deleteScheduleTileWidgetRepository = async (id: string): Promise<void> => {
  await delData<SuccessResponse>(API_URLS.DELETE_SCHEDULE_TILE_WIDGET(id));
};
